import axios from "axios";
import apiConfig from "../config/apiConfig";

const jobApiInstance = axios.create({
  baseURL: apiConfig.endpoints.jobService.baseURL,
  timeout: 15000,
});

const getJobs = async (params = {}) => {
  try {
    const response = await jobApiInstance.get(
      apiConfig.endpoints.jobService.routes.getJobs,
      { params }
    );
    return { data: response.data };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const getTags = async () => {
  try {
    const response = await jobApiInstance.get(
      apiConfig.endpoints.jobService.routes.getTags
    );
    return { data: response.data };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const PostJob = async (jobdata) => {
  try {
    const response = await jobApiInstance.post(
      apiConfig.endpoints.jobService.routes.postJob,
      jobdata
    );
    return { data: response.data };
  } catch (error) {
    return error.response?.data || error.message || error;
  }
};

const jobApi = {
  getJobs,
  getTags,
  PostJob
};

export default jobApi;
